/** Downsteps all `h1` headings to be `h2` headings */
export default function downstepHeadings(element: HTMLElement) {
	for (const headingOne of element.querySelectorAll('h1')) {
		const headingTwo = document.createElement('h2');
		
		for (const attribute of headingOne.attributes) {
			headingTwo.setAttribute(attribute.name, attribute.value);
		}
		
		headingTwo.append(...headingOne.childNodes);
		headingOne.replaceWith(headingTwo);
	}
}
